var site = site || {};
var $BV = $BV || {};

site.spp = site.spp || {};
site.spp.globalStyleOverrides = false;
site.spp.globalStyleOverridesCallbacks = [];

(function ($) {
  Drupal.behaviors.sppProductLayoutV1 = {
    attach: function (context) {
      var url = document.location.href;
      var hash = url.substring(url.indexOf('#') + 1);
      var sppData = page_data['catalog-spp'];
      var product = sppData['products'][0];
      var skus = product.skus;
      var homePageUrl = window.location.protocol + '//' + window.location.hostname;

      if ((hash === 'writeareview') && (typeof $BV !== 'undefined')) {
        $BV.getConfiguration().doShowSubmission();
      }
      $('body').addClass('pc_spp_view');

      if ($('.device-pc').length && Drupal.cl.hasPersonalization()) {
        site.profile.products.SPP.init(page_data['catalog-spp']);
      }

      // trigger sku purge and default selection when getting the L2 prodcache status
      var $qs = $('.module-spp-detail');

      $(document).on('inventory_status_stored', function () {
        // 2019 Redesign - check if function is real before loading it
        if (typeof site.quickshop.setDefaultSkuSelection !== 'undefined') {
          site.quickshop.setDefaultSkuSelection(product, $qs);
        }
        // check to see if we have any "isOrderable" or "Coming Soon" skus, if "no" go to homepage
        var isOrderableSku = $(product.skus).filter(function () {
          var undef;

          return ($(document).data(this.SKU_ID) !== undef) && (($(document).data(this.SKU_ID).isOrderable === 1)
            || ($(document).data(this.SKU_ID).INVENTORY_STATUS === 3) || ($(document).data(this.SKU_ID).INVENTORY_STATUS === 2 && Drupal.settings.display_notify_tos));
        })[0];
        var isDisplayableSku = $(product.skus).filter(function () {
          var undef;
          var sku = $(document).data(this.SKU_ID);

          return typeof site.features.spp_displayable_status !== 'undefined'
            && (sku !== undef && site.features.spp_displayable_status[sku.INVENTORY_STATUS]);
        })[0];

        if (typeof isOrderableSku == 'undefined' && !isDisplayableSku) {
          if ($('a.logo-link').length > 0) {
            homePageUrl = $('a.logo-link').attr('href');
          } else if ($('a.left_logo-link').length > 0) {
            homePageUrl = $('a.left_logo-link').attr('href');
          }
          window.location.href = homePageUrl;
        }
      });

      // remove sold out skus before select box is inited.
      var $shadePicker = $('.product-shade-picker__shades, .product-shade-picker__show-all-shades-panel, .product-swatch-selector .sku_select, .product-size-selector .sku_select', context);
      var sku;

      for (sku in skus) {
        if (!site.productData.isSkuDisplayable(skus[sku])) {
          $shadePicker.find('[data-skubaseid="' + skus[sku].SKU_BASE_ID + '"]').remove();
        }
      }

      $('.device-pc .spp__container select', context).selectbox({
        onOpen: function (inst) {
          if (inst.input.hasClass('sku_select')) {
            var currentSelect = $(this);

            currentSelect.parent().find('ul.sbOptions').css('overflow', 'auto');

            currentSelect.find('option').each(function (index) {
              var skuOption = $(this);
              var skuShade = skuOption.data('skushade');
              var skuCount = index + 1;

              skuOption.parents('.selectbox-wrapper').find('.sbOptions li:nth-child(' + skuCount + ')').css('background-color', skuShade);
            });
          }
        }
      });

      $('.device-mobile .js-product-full-content .js-product-shade-picker-shades', context).flexslider({
        animation: 'slide',
        animationLoop: false,
        itemWidth: 80,
        minItems: 5,
        move: 1,
        controlNav: false,
        directionNav: false,
        slideshow: false,
        start: function () {
          $('.product-shade-picker__shade-inner', context).css('display', 'flex');
        }
      });
    }
  };
})(jQuery);
